import { FC, useMemo } from "react";
import { AppTester } from "../../supporting";
import { useHistory, useLocation } from "react-router-dom";
import useSingleTagModal from "./useSingleTagModal";
import { useTranslation } from "react-i18next";

const useSplitTagsConfig = (): { tagsNavItems: any[], shouldDisplaySplitTags: boolean } => {
  const location = useLocation();
  const isSuperPuper = AppTester.isSuperPuper()
  const [showTagModal] = useSingleTagModal();
  const history = useHistory();
  const { t, i18n: { language } } = useTranslation();

  const shouldDisplaySplitTags = useMemo(() => {
    return true;
  }, [])

  const tagsNavItems = useMemo(() => {
    if (isSuperPuper) {
      return []
    }
    if (shouldDisplaySplitTags) {
      return [
        {
          active: location.pathname.startsWith('/competencies'),
          content: t("nav.competencies"),
          action: (ev: any) => {
            ev.preventDefault();
            history.push('/competencies');
          },
        },
        {
          active: location.pathname.startsWith('/tags'),
          content: t("nav.tags"),
          action: (ev: any) => {
            history.push('/tags');
          },
          isModal: true,
        },
      ]
    }
    return [
      {
        active: location.pathname.startsWith('/tags'),
        content: t("nav.explore_tags"),
        action: (ev: any) => {
          showTagModal();
        },
      },
    ]
  }, [shouldDisplaySplitTags, location.pathname, language, isSuperPuper]);

  return useMemo(() => {
    return {
      tagsNavItems,
      shouldDisplaySplitTags,
    }
  }, [shouldDisplaySplitTags, tagsNavItems])
}

export default useSplitTagsConfig;import { FC, useMemo } from "react";
import { AppTester } from "../../supporting";
import { useHistory, useLocation } from "react-router-dom";
import useSingleTagModal from "./useSingleTagModal";
import { useTranslation } from "react-i18next";

const useSplitTagsConfig = (): { tagsNavItems: any[], shouldDisplaySplitTags: boolean } => {
  const location = useLocation();
  const isSuperPuper = AppTester.isSuperPuper()
  const [showTagModal] = useSingleTagModal();
  const history = useHistory();
  const { t, i18n: { language } } = useTranslation();

  const shouldDisplaySplitTags = useMemo(() => {
    return true;
  }, [])

  const tagsNavItems = useMemo(() => {
    if (isSuperPuper) {
      return []
    }
    if (shouldDisplaySplitTags) {
      return [
        {
          active: location.pathname.startsWith('/competencies'),
          content: t("nav.competencies"),
          action: (ev: any) => {
            ev.preventDefault();
            history.push('/competencies');
          },
        },
        {
          active: location.pathname.startsWith('/tags'),
          content: t("nav.tags"),
          action: (ev: any) => {
            history.push('/tags');
          },
          isModal: true,
        },
      ]
    }
    return [
      {
        active: location.pathname.startsWith('/tags'),
        content: t("nav.explore_tags"),
        action: (ev: any) => {
          showTagModal();
        },
      },
    ]
  }, [shouldDisplaySplitTags, location.pathname, language, isSuperPuper]);

  return useMemo(() => {
    return {
      tagsNavItems,
      shouldDisplaySplitTags,
    }
  }, [shouldDisplaySplitTags, tagsNavItems])
}

export default useSplitTagsConfig;